import { render, staticRenderFns } from "./PhyMonitor.vue?vue&type=template&id=650efeec&scoped=true"
import script from "./PhyMonitor.vue?vue&type=script&lang=js"
export * from "./PhyMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650efeec",
  null
  
)

export default component.exports